export default __webpack_public_path__ + "static/media/button_menu.6d7c1ee6.png";